import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IAllTemplatePoliciesResponse } from "../models/TemplatePolicy";
import { IPart } from "../models/Part";
import { DefaultResponseWithData } from "../models/system";

export default function useTemplateProductDescription(part?: IPart, enabled: boolean = true) {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const productDescription = useQuery({
    queryKey: ["productDescription", part?.id],
    queryFn: () => get<DefaultResponseWithData<string>>(`/template/product-description/${part?.id}`),
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled: enabled && !!part?.id,
  });

  const updateProductDescription = useMutation({
    mutationFn: (partId: string) => get<DefaultResponseWithData<string>>(`/template/product-description/${partId}?save=true`),
    onSuccess: (data) => {
      queryClient.invalidateQueries(["parts"]);
    },
  });

  const bulkUpdateProductDescription = useMutation({
    mutationFn: (partIds: string[]) => post<string[], DefaultResponseWithData<string>>(`/template/product-description/bulk?save=true`, partIds),
    onSuccess: (data) => {
      queryClient.invalidateQueries(["parts"]);
      queryClient.invalidateQueries(["pagedTable"]);
    },
  });

  return {
    productDescription,
    updateProductDescription,
    bulkUpdateProductDescription,
  };
} 